import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    inner: {
        position: "absolute",
        right: '15px',
        top: '10px'
    },
    sidebar: {
        header: {
            position: "relative",
        }
    },
}